import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { GitFork, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyFlowsProps {
  onCreate: () => void;
  onHowItWorks: () => void;
}

// Estado vazio no padrão do Teste A/B e do Hook Track: explica o recurso, cria ou abre o "Como funciona?".
export function EmptyFlows({ onCreate, onHowItWorks }: EmptyFlowsProps) {
  useLanguage();
  return (
    <div className="flex min-h-[calc(100vh-200px)] flex-col items-center justify-center px-4 text-center">
      <div className="mb-8 flex justify-center">
        <div className="rounded-full bg-blue-100 p-6">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-500">
            <GitFork size={32} className="text-white" aria-hidden="true" />
          </div>
        </div>
      </div>

      <h2 className="mx-auto mb-3 max-w-4xl px-2 text-lg font-semibold sm:text-xl md:text-2xl">
        {translateInterfaceText("Crie funis de vídeo em que o visitante escolhe o caminho até a compra")}</h2>
      <p className="mx-auto mb-8 max-w-md text-sm leading-relaxed text-muted-foreground md:text-base">
        {translateInterfaceText("Ligue vídeos curtos com perguntas e opções, leve cada visitante pela resposta dele até o checkout e veja onde cada um decide")}</p>

      <div className="flex flex-col gap-4 sm:flex-row">
        <Button onClick={onCreate} className="flex min-h-[44px] items-center justify-center gap-2 px-6">
          <Plus className="h-4 w-4" aria-hidden="true" />
          {translateInterfaceText("Criar fluxo")}</Button>
        <Button
          variant="outline"
          onClick={onHowItWorks}
          className="min-h-[44px] px-6 hover:bg-[#F4F6FA] hover:text-[#111827]"
        >
          {translateInterfaceText("Como funciona?")}</Button>
      </div>
    </div>
  );
}

export function NoFlowsMatch({ onClear }: { onClear: () => void }) {
  useLanguage();
  return (
    <section className="flex flex-col items-center gap-3 rounded-2xl border border-[#D9E0EA] bg-white px-6 py-12 text-center">
      <p className="text-sm text-[#4B5563]">{translateInterfaceText("Nenhum fluxo encontrado com esse filtro.")}</p>
      <Button variant="outline" onClick={onClear} className="rounded-xl">
        {translateInterfaceText("Limpar busca e filtros")}</Button>
    </section>
  );
}
